import { render, staticRenderFns } from "./EntRoleList.vue?vue&type=template&id=2af63d2a&scoped=true&"
import script from "./EntRoleList.vue?vue&type=script&lang=js&"
export * from "./EntRoleList.vue?vue&type=script&lang=js&"
import style0 from "./EntRoleList.vue?vue&type=style&index=0&id=2af63d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af63d2a",
  null
  
)

export default component.exports